export default function NosotrosContent() {

    return (
        <div className="w-75 mx-auto pt-5" style={{textAlign:'justify'}}>
             <h4><span ><strong>MISION</strong></span></h4>
            <p >SAOS ALTURAS S.A.S, cuenta con personal profesional calificado para brindar el mejor servicio en capacitación para trabajo en alturas, de esta manera buscamos posicionarnos como el mejor centro de entrenamiento a nivel nacional, brindando a nuestros clientes un servicio oportuno y de alta calidad, siempre pensando en las necesidades de nuestros clientes.</p>
            <hr />
            <h4><span ><strong>VISION </strong></span></h4>
            <p >Para el año 2025, SAOS ALTURAS S.A.S, estaremos dentro de las mejores empresas a nivel Nacional, consolidaremos nuestros servicios a través del reconocimiento de nuestros clientes y comunidad como la mejor opción para el desarrollo de formación laboral en cuanto a capacitación y certificación de Trabajo Seguro en Alturas y Actividades de Alto Riesgo.</p>
            <p >Contaremos con infraestructura propia para nuestras operaciones, con  personal competente y áreas.</p>

        </div>
    )
}